import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from '../components/AuthModal';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import profileImage from '../assets/ProfileImage.png';
import icon43 from '../assets/43.png';
import instagramIcon from '../assets/instagram2.png';
import twitterIcon from '../assets/twitter1.png';
import PRinfo2 from '../assets/PRinfo_part2.png';
import PRinfo3 from '../assets/PRinfo_part3.png';
import PRinfo4 from '../assets/PRinfo_part4.png';
import PRinfo5 from '../assets/PRinfo_part5.png';
import PRinfo6 from '../assets/PRinfo_part6.png';
import PRinfo7 from '../assets/PRinfo_part7.png';
import PRinfo8 from '../assets/PRinfo_part8.png';
import FollowingIcon from '../assets/FollowingIcon.png';
import newbackground from '../assets/newbackground.png';
import unLikeIconImage from '../assets/unLike_icon.png';
import likeIcon from '../assets/Like_icon.png';
import sobaka from '../assets/@.png';
import solanaIcon from '../assets/solana-icon.png';
import coins_1 from '../assets/coins 1.png';

export default function ProfilePage() {
  const [activeTab, setActiveTab] = useState('collection');
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [waitingListData, setWaitingListData] = useState([]);
  const [waitingListLoading, setWaitingListLoading] = useState(false);
  const [waitingListError, setWaitingListError] = useState(null);
  const waitingListFetcherRef = useRef(null);
  const [favoritesData, setFavoritesData] = useState([]);
  const [favoritesLoading, setFavoritesLoading] = useState(false);
  const [favoritesError, setFavoritesError] = useState(null);
  const favoritesFetcherRef = useRef(null);
  const [hoveredFavoriteIndex, setHoveredFavoriteIndex] = useState(null);
  const [animatingFavoriteIndex, setAnimatingFavoriteIndex] = useState(null);
  const [collectionsData, setCollectionsData] = useState([]);
  const [collectionsLoading, setCollectionsLoading] = useState(false);
  const [collectionsError, setCollectionsError] = useState(null);
  const collectionsFetcherRef = useRef(null);
  const [animatingCollectionIndex, setAnimatingCollectionIndex] = useState(null);
  const { user, fetchWaitingListCollections, fetchFavorites, removeFromFavorites, fetchCollections, removeFromCollections } = useAuth();
  const navigate = useNavigate();

  const waitingListCardPositions = [
    { left: 'clamp(10px, 1.04vw, 20px)', top: 'clamp(13px, 1.35vw, 26px)' },
    { left: 'clamp(216px, 22.55vw, 433px)', top: 'clamp(13px, 1.35vw, 26px)' },
    { left: 'clamp(423px, 44.06vw, 846px)', top: 'clamp(13px, 1.35vw, 26px)' },
    { left: 'clamp(630px, 65.63vw, 1260px)', top: 'clamp(13px, 1.35vw, 26px)' },
    { left: 'clamp(10px, 1.04vw, 20px)', top: 'clamp(132px, 13.8vw, 265px)' },
    { left: 'clamp(216px, 22.55vw, 433px)', top: 'clamp(132px, 13.8vw, 265px)' },
    { left: 'clamp(423px, 44.06vw, 846px)', top: 'clamp(132px, 13.8vw, 265px)' },
    { left: 'clamp(630px, 65.63vw, 1260px)', top: 'clamp(132px, 13.8vw, 265px)' },
    { left: 'clamp(10px, 1.04vw, 20px)', top: 'clamp(252px, 26.25vw, 504px)' },
    { left: 'clamp(216px, 22.55vw, 433px)', top: 'clamp(252px, 26.25vw, 504px)' },
    { left: 'clamp(423px, 44.06vw, 846px)', top: 'clamp(252px, 26.25vw, 504px)' },
    { left: 'clamp(630px, 65.63vw, 1260px)', top: 'clamp(252px, 26.25vw, 504px)' },
  ];

  useEffect(() => {
    waitingListFetcherRef.current = fetchWaitingListCollections;
  }, [fetchWaitingListCollections]);

  useEffect(() => {
    favoritesFetcherRef.current = fetchFavorites;
  }, [fetchFavorites]);

  useEffect(() => {
    collectionsFetcherRef.current = fetchCollections;
  }, [fetchCollections]);

  useEffect(() => {
    if (activeTab !== 'waitingList') {
      return;
    }

    let isMounted = true;

    const loadWaitingList = async () => {
      setWaitingListLoading(true);
      setWaitingListError(null);

      const fetcher = waitingListFetcherRef.current;
      if (!fetcher) {
        setWaitingListLoading(false);
        return;
      }

      const result = await fetcher();

      if (!isMounted) {
        return;
      }

      if (!result.success) {
        setWaitingListError(result.message || 'Не удалось загрузить Waiting List');
        setWaitingListData([]);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
      } else {
        setWaitingListData(result.collections || []);
      }

      setWaitingListLoading(false);
    };

    loadWaitingList();

    return () => {
      isMounted = false;
    };
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== 'favorites') {
      return;
    }

    let isMounted = true;

    const loadFavorites = async () => {
      setFavoritesLoading(true);
      setFavoritesError(null);

      const fetcher = favoritesFetcherRef.current;
      if (!fetcher) {
        setFavoritesLoading(false);
        return;
      }

      const result = await fetcher();

      if (!isMounted) {
        return;
      }

      if (!result.success) {
        setFavoritesError(result.message || 'Не удалось загрузить favorites');
        setFavoritesData([]);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
      } else {
        setFavoritesData(result.items || []);
      }

      setFavoritesLoading(false);
    };

    loadFavorites();

    return () => {
      isMounted = false;
    };
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'waitingList' && !user) {
      setIsAuthModalOpen(true);
    }
  }, [activeTab, user]);

  useEffect(() => {
    if (activeTab !== 'collection') {
      return;
    }

    let isMounted = true;

    const loadCollections = async () => {
      setCollectionsLoading(true);
      setCollectionsError(null);

      const fetcher = collectionsFetcherRef.current;
      if (!fetcher) {
        setCollectionsLoading(false);
        return;
      }

      const result = await fetcher();

      if (!isMounted) {
        return;
      }

      if (!result.success) {
        setCollectionsError(result.message || 'Не удалось загрузить коллекции');
        setCollectionsData([]);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
      } else {
        setCollectionsData(result.items || []);
      }

      setCollectionsLoading(false);
    };

    loadCollections();

    return () => {
      isMounted = false;
    };
  }, [activeTab]);

  useEffect(() => {
    if (!user) {
      setWaitingListData([]);
      setWaitingListError(null);
    }
  }, [user]);

  const getEmailPrefix = (email) => {
    if (!email) return '';
    return email.substring(0, 5);
  };

  const handleRemoveFromFavorites = async (e, fav, index) => {
    e.stopPropagation(); // Предотвращаем переход на страницу NFT
    
    if (!fav.slug) {
      return;
    }

    // Запускаем анимацию перед удалением
    setAnimatingFavoriteIndex(index);
    setTimeout(() => setAnimatingFavoriteIndex(null), 300);

    const nftIndex = typeof fav.nftIndex === 'number' ? fav.nftIndex : 0;
    const result = await removeFromFavorites(fav.slug, nftIndex);

    if (result.success) {
      // Обновляем список favorites, удаляя текущий элемент
      setFavoritesData(prevData => 
        prevData.filter(item => 
          !(item.slug === fav.slug && (item.nftIndex ?? 0) === nftIndex)
        )
      );
    } else {
      console.error('Ошибка удаления из favorites:', result.message);
      setAnimatingFavoriteIndex(null);
    }
  };

  const handleRemoveFromCollections = async (e, collection, index) => {
    e.stopPropagation(); // Предотвращаем переход на страницу коллекции
    
    if (!collection.slug) {
      return;
    }

    // Запускаем анимацию перед удалением
    setAnimatingCollectionIndex(index);
    setTimeout(() => setAnimatingCollectionIndex(null), 300);

    const result = await removeFromCollections(collection.slug);

    if (result.success) {
      // Обновляем список collections, удаляя текущий элемент
      setCollectionsData(prevData => 
        prevData.filter(item => item.slug !== collection.slug)
      );
    } else {
      console.error('Ошибка удаления из collections:', result.message);
      setAnimatingCollectionIndex(null);
    }
  };

  return (
    <div className="h-screen bg-[#1E1E1E] text-white main-font flex flex-col overflow-hidden">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="profile" />

        {/* Main Content */}
        <main className="flex-1 bg-[#1E1E1E] flex flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="relative" style={{ 
              width: '86.51vw', 
              maxWidth: '1661px',
              margin: '0',
              minHeight: '100%'
            }}>
              {/* Background Image */}
              <img 
                src={newbackground}
                alt="Background"
                className="absolute object-cover"
                style={{
                  width: 'clamp(830px, 86.46vw, 1660px)',
                  height: 'clamp(313px, 32.66vw, 627px)',
                  left: '0',
                  top: '0'
                }}
              />
              {/* Profile Header Rectangle */}
              <div 
                className="absolute bg-[#000000] flex items-center rounded-br-[clamp(8px,0.42vw,8px)]"
                style={{
                  left: '0',
                  top: '0',
                  width: 'clamp(80px, 5.78vw, 111px)',
                  height: 'clamp(30px, 2.08vw, 40px)'
                }}
              >
                <span 
                  style={{
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(14px, 0.94vw, 18px)',
                    color: '#FFFFFF',
                    marginLeft: 'clamp(15px, 1.56vw, 30px)'
                  }}
                >
                  Profile
                </span>
              </div>

              {/* Profile Image */}
              <div 
                className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(40px, 4.17vw, 80px)',
                  top: 'clamp(40px, 4.17vw, 80px)',
                  width: 'clamp(200px, 20.83vw, 400px)',
                  height: 'clamp(220px, 22.92vw, 440px)'
                }}
              >
                <img 
                  src={user?.avatar || profileImage} 
                  alt="Profile"
                  className="w-full h-full object-cover rounded-[clamp(4px,0.21vw,4px)]"
                />
              </div>

              {/* Top Left Corner Element - L shape */}
              <div className="absolute" style={{ left: 'clamp(35px, 3.58vw, 70px)', top: 'clamp(35px, 3.65vw, 70px)' }}>
                {/* Horizontal part (top) */}
                <div 
                  style={{
                    width: 'clamp(30px, 3.13vw, 60px)',
                    height: 'clamp(3px, 0.31vw, 6px)',
                    backgroundColor: '#770E0E',
                    opacity: 0.5
                  }}
                />
                {/* Vertical part (left) */}
                <div 
                  style={{
                    width: 'clamp(3px, 0.31vw, 6px)',
                    height: 'clamp(30px, 3.13vw, 60px)',
                    backgroundColor: '#770E0E',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    opacity: 0.5
                  }}
                />
              </div>

              {/* Bottom Left Corner Element - L shape */}
              <div className="absolute" style={{ left: 'clamp(35px, 3.58vw, 70px)', top: 'clamp(266px, 27.66vw, 532px)' }}>
                {/* Horizontal part (bottom) */}
                <div 
                  style={{
                    width: 'clamp(30px, 3.13vw, 60px)',
                    height: 'clamp(3px, 0.31vw, 6px)',
                    backgroundColor: '#770E0E',
                    opacity: 0.5,
                    position: 'absolute',
                    bottom: '0',
                    left: '0'
                  }}
                />
                {/* Vertical part (left) */}
                <div 
                  style={{
                    width: 'clamp(3px, 0.31vw, 6px)',
                    height: 'clamp(30px, 3.13vw, 60px)',
                    backgroundColor: '#770E0E',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    opacity: 0.5
                  }}
                />
              </div>

              {/* Horizontal Line between Photo and Right Section */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(235px, 24.13vw, 470px)',
                  top: 'clamp(150px, 15.625vw, 300px)',
                  width: 'clamp(19px, 2vw, 38px)',
                  height: 'clamp(2.5px, 0.26vw, 5px)',
                  backgroundColor: '#770E0E',
                  opacity: 0.5
                }}
              />

              {/* Main Rectangle */}
              <div 
                className="absolute border rounded-[clamp(12px,0.63vw,12px)]"
                style={{
                  left: 'clamp(250px, 26.04vw, 500px)',
                  top: 'clamp(30px, 3.12vw, 60px)',
                  width: 'clamp(220px, 22.92vw, 440px)',
                  height: 'clamp(240px, 25vw, 480px)',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  borderColor: 'rgba(170, 0, 0, 0.4)',
                  borderWidth: '1px'
                }}
              >
                {/* First Element - Name */}
                <div 
                  className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                  style={{
                    left: 'clamp(20px, 2.08vw, 40px)',
                    top: 'clamp(15px, 1.56vw, 30px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    height: 'clamp(22.5px, 2.34vw, 45px)',
                    backgroundColor: '#171717'
                  }}
                >
                  {/* Square with @ */}
                  <div 
                    className="absolute flex items-center justify-center rounded-[clamp(4px,0.21vw,4px)]"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(22.5px, 2.34vw, 45px)',
                      height: 'clamp(22.5px, 2.34vw, 45px)',
                      backgroundColor: '#1D4030'
                    }}
                  >
                    <img 
                      src={sobaka}
                      alt="Twitter"
                      style={{
                        width: 'clamp(7px, 0.74vw, 14px)',
                        height: 'clamp(7px, 0.74vw, 14px)'
                      }}
                    />
                  </div>
                  
                  {/* Nickname text */}
                  <span 
                    style={{
                      position: 'absolute',
                      left: 'clamp(32.5px, 3.39vw, 65px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 'clamp(137.5px, 14.32vw, 275px)',
                      opacity: 0.8
                    }}
                  >
                    @{user?.nickname || getEmailPrefix(user?.email)}
                  </span>
                </div>

                {/* Second Element - Collector */}
                <div 
                  className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                  style={{
                    left: 'clamp(20px, 2.08vw, 40px)',
                    top: 'clamp(42.5px, 4.43vw, 85px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    height: 'clamp(22.5px, 2.34vw, 45px)',
                    backgroundColor: '#171717'
                  }}
                >
                  {/* Square with blockchain icon */}
                  <div 
                    className="absolute flex items-center justify-center rounded-[clamp(4px,0.21vw,4px)]"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(22.5px, 2.34vw, 45px)',
                      height: 'clamp(22.5px, 2.34vw, 45px)',
                      backgroundColor: '#1D4030'
                    }}
                  >
                    <img 
                      src={require('../assets/blockchain.png')}
                      alt="Blockchain"
                      style={{
                        width: 'clamp(12px, 1.25vw, 24px)',
                        height: 'clamp(12px, 1.25vw, 24px)'
                      }}
                    />
                  </div>
                  
                  {/* Collector text */}
                  <span 
                    style={{
                      position: 'absolute',
                      left: 'clamp(32.5px, 3.39vw, 65px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8
                    }}
                  >
                    Collector
                  </span>
                </div>

                {/* Third Element - Instagram */}
                <div 
                  className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                  style={{
                    left: 'clamp(20px, 2.08vw, 40px)',
                    top: 'clamp(70px, 7.3vw, 140px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    height: 'clamp(22.5px, 2.34vw, 45px)',
                    backgroundColor: '#171717'
                  }}
                >
                  {/* Square with instagram icon */}
                  <div 
                    className="absolute flex items-center justify-center rounded-[clamp(4px,0.21vw,4px)]"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(22.5px, 2.34vw, 45px)',
                      height: 'clamp(22.5px, 2.34vw, 45px)',
                      backgroundColor: '#790E0E'
                    }}
                  >
                    <img 
                      src={instagramIcon}
                      alt="Instagram"
                      style={{
                        width: 'clamp(9px, 0.94vw, 18px)',
                        height: 'clamp(9px, 0.94vw, 18px)'
                      }}
                    />
                  </div>
                  
                  {/* Instagram text */}
                  <span
                    style={{
                      position: 'absolute',
                      left: 'clamp(32.5px, 3.39vw, 65px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 'clamp(112.5px, 11.72vw, 225px)',
                      opacity: 0.8
                    }}
                  >
                    <a
                      href={
                        user?.instagram
                          ? user.instagram.startsWith('http')
                            ? user.instagram
                            : `https://${user.instagram}`
                          : '#'
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#FFFFFF',
                        textDecoration: 'none',
                        cursor: user?.instagram ? 'pointer' : 'default',
                        transition: 'color 0.2s ease, opacity 0.2s ease',
                      }}
                      onMouseEnter={e => (e.currentTarget.style.textDecoration = 'underline')}
                      onMouseLeave={e => (e.currentTarget.style.textDecoration = 'none')}
                    >
                      {user?.instagram
                        ? user.instagram
                            .replace(/https?:\/\/(www\.)?instagram\.com\//, '')
                            .replace(/\/$/, '')
                        : '- - -'}
                    </a>
                  </span>
                  
                  {/* Right icon */}
                  <img 
                    src={icon43}
                    alt="Icon"
                    className="absolute"
                    style={{
                      right: 'clamp(5px, 0.52vw, 10px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 'clamp(12px, 1.25vw, 24px)',
                      height: 'clamp(12px, 1.25vw, 24px)'
                    }}
                  />
                </div>

                {/* Fourth Element - Twitter */}
                <div 
                  className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                  style={{
                    left: 'clamp(20px, 2.08vw, 40px)',
                    top: 'clamp(97.5px, 10.21vw, 195px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    height: 'clamp(22.5px, 2.34vw, 45px)',
                    backgroundColor: '#171717'
                  }}
                >
                  {/* Square with twitter icon */}
                  <div 
                    className="absolute flex items-center justify-center rounded-[clamp(4px,0.21vw,4px)]"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(22.5px, 2.34vw, 45px)',
                      height: 'clamp(22.5px, 2.34vw, 45px)',
                      backgroundColor: '#790E0E'
                    }}
                  >
                    <img 
                      src={twitterIcon}
                      alt="Twitter"
                      style={{
                        width: 'clamp(9px, 0.94vw, 18px)',
                        height: 'clamp(9px, 0.94vw, 18px)'
                      }}
                    />
                  </div>
                  
                  {/* Twitter text */}
                  <span
                    style={{
                      position: 'absolute',
                      left: 'clamp(32.5px, 3.39vw, 65px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 'clamp(112.5px, 11.72vw, 225px)',
                      opacity: 0.8
                    }}
                  >
                    <a
                      href={
                        user?.twitter
                          ? user.twitter.startsWith('http')
                            ? user.twitter
                            : `https://${user.twitter}`
                          : '#'
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#FFFFFF',
                        textDecoration: 'none',
                        cursor: user?.twitter ? 'pointer' : 'default',
                        transition: 'color 0.2s ease, opacity 0.2s ease',
                      }}
                      onMouseEnter={e => (e.currentTarget.style.textDecoration = 'underline')}
                      onMouseLeave={e => (e.currentTarget.style.textDecoration = 'none')}
                    >
                      {user?.twitter
                        ? user.twitter
                            .replace(/https?:\/\/(www\.)?twitter\.com\//, '')
                            .replace(/https?:\/\/(www\.)?x\.com\//, '')
                            .replace(/\/$/, '')
                        : '- - -'}
                    </a>
                  </span>
                  
                  {/* Right icon */}
                  <img 
                    src={icon43}
                    alt="Icon"
                    className="absolute"
                    style={{
                      right: 'clamp(5px, 0.52vw, 10px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 'clamp(12px, 1.25vw, 24px)',
                      height: 'clamp(12px, 1.25vw, 24px)'
                    }}
                  />
                </div>

                {/* Bio Section */}
                <div 
                  className="absolute rounded-[clamp(4px,0.21vw,4px)]"
                  style={{
                    left: 'clamp(20px, 2.08vw, 40px)',
                    top: 'clamp(125px, 13.02vw, 250px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    height: 'clamp(100px, 10.42vw, 200px)',
                    backgroundColor: '#191919'
                  }}
                >
                  {/* Bio Header */}
                  <div 
                    className="absolute flex items-center justify-center rounded-t-[clamp(4px,0.21vw,4px)]"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(180px, 18.75vw, 360px)',
                      height: 'clamp(15px, 1.56vw, 30px)',
                      backgroundColor: '#790E0E'
                    }}
                  >
                    <span 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(12px, 0.83vw, 16px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        opacity: 0.8
                      }}
                    >
                      Bio
                    </span>
                  </div>
                  
                  {/* Bio Text */}
                  <div
                    style={{
                      position: 'absolute',
                      left: 'clamp(10px, 1.04vw, 20px)',
                      top: 'clamp(25px, 2.6vw, 50px)',
                      right: 'clamp(10px, 1.04vw, 20px)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: 'rgba(255, 255, 255, 0.9)',
                      lineHeight: '1.4',
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                      opacity: 0.8
                    }}
                  >
                    {user?.bio || 'There is a day when i thought and then it bacame a name of the collection, sounds like a situation when a thought is a name of the collection.'}
                  </div>
                </div>
              </div>

              {/* PRinfo Images */}
              {/* Row 1 */}
              <img 
                src={PRinfo7}
                alt="PRinfo 1"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(505px, 52.6vw, 1010px)',
                  top: 'clamp(40px, 4.17vw, 80px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              <img 
                src={PRinfo2}
                alt="PRinfo 2"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(577px, 60.1vw, 1154px)',
                  top: 'clamp(40px, 4.17vw, 80px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              <img 
                src={PRinfo3}
                alt="PRinfo 3"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(650px, 67.71vw, 1300px)',
                  top: 'clamp(40px, 4.17vw, 80px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              <img 
                src={PRinfo8}
                alt="PRinfo 4"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(720px, 75vw, 1440px)',
                  top: 'clamp(40px, 4.17vw, 80px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              {/* Row 2 */} 
              <img 
                src={PRinfo4}
                alt="PRinfo 4"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(571px, 56.25vw, 1083px)',
                  top: 'clamp(115px, 10.92vw, 230px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              <img 
                src={PRinfo5}
                alt="PRinfo 5"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(639px, 63.9vw, 1278px)',
                  top: 'clamp(115px, 10.92vw, 230px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              <img 
                src={PRinfo6}
                alt="PRinfo 6"
                className="absolute object-cover rounded-[clamp(4px,0.21vw,4px)]"
                style={{
                  left: 'clamp(715px, 71.53vw, 1430px)',
                  top: 'clamp(115px, 10.92vw, 230px)',
                  width: 'clamp(110px, 11.46vw, 220px)',
                  height: 'clamp(110px, 11.46vw, 220px)'
                }}
              />

              {/* Following Rectangle */}
              <div 
                className="absolute border border-[#57E8A6] bg-transparent rounded-[clamp(6px,0.31vw,6px)]"
                style={{
                  left: 'clamp(755px, 78.65vw, 1510px)',
                  top: 'clamp(285px, 29.69vw, 570px)',
                  width: 'clamp(60px, 6.25vw, 120px)',
                  height: 'clamp(17px, 1.82vw, 35px)'
                }}
              >
                <span 
                  style={{
                    position: 'absolute',
                    left: 'clamp(8px, 0.83vw, 16px)',
                    top: 'clamp(4px, 0.42vw, 8px)',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(6px, 0.63vw, 12px)',
                    color: '#FFFFFF',
                    opacity: 0.8
                  }}
                >
                  Following
                </span>
                
                {/* Square with icon */}
                <div 
                  className="absolute bg-[#6FFF64] bg-opacity-10 rounded-[clamp(2px,0.1vw,2px)]"
                  style={{
                    left: 'clamp(42px, 4.43vw, 85px)',
                    top: '0',
                    width: 'clamp(17px, 1.82vw, 35px)',
                    height: 'clamp(17px, 1.82vw, 35px)',
                    borderLeft: '1px solid #57E8A6'
                  }}
                >
                  <img 
                    src={FollowingIcon}
                    alt="Following"
                    className="absolute"
                    style={{
                      left: 'clamp(3px, 0.42vw, 8px)',
                      top: 'clamp(4px, 0.42vw, 8px)',
                      width: 'clamp(9px, 0.94vw, 18px)',
                      height: 'clamp(9px, 0.94vw, 18px)'
                    }}
                  />
                </div>
              </div>

              {/* Navigation Section */}
              <div 
                className="absolute bg-[#000000] border-t-4 border-b-4 border-[#8F0A0A] flex"
                style={{
                  left: '0',
                  top: 'clamp(312px, 32.55vw, 625px)',
                  width: 'clamp(830px, 86.46vw, 1660px)',
                  height: 'clamp(22px, 2.29vw, 44px)',
                  zIndex: 100
                }}
              >
                {/* Пустое пространство слева */}
                <div style={{ width: 'clamp(241px, 25.1vw, 482px)' }}></div>

                {/* Collection Button - Active */}
                <button 
                  onClick={() => setActiveTab('collection')}
                  className={`relative border-r-4 border-l-4 border-[#AB0000] hover:opacity-90 transition-opacity flex items-center justify-center ${
                    activeTab === 'collection' 
                      ? 'bg-[#2D2D2D]' 
                      : 'bg-[#161616]'
                  }`}
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(18px, 1.88vw, 36px)',
                    cursor: 'pointer'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8,
                      pointerEvents: 'none'
                    }}
                  >
                    Collection
                  </span>
                </button>

                {/* NFT's Button */}
                <button 
                  onClick={() => setActiveTab('nfts')}
                  className={`relative border-r-4 border-[#AB0000] hover:opacity-90 transition-opacity flex items-center justify-center ${
                    activeTab === 'nfts' 
                      ? 'bg-[#2D2D2D]' 
                      : 'bg-[#161616]'
                  }`}
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(18px, 1.88vw, 36px)',
                    cursor: 'pointer'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8,
                      pointerEvents: 'none'
                    }}
                  >
                    NFT's
                  </span>
                </button>

                {/* Following Button */}
                <button 
                  onClick={() => setActiveTab('following')}
                  className={`relative border-r-4 border-[#AB0000] hover:opacity-90 transition-opacity flex items-center justify-center ${
                    activeTab === 'following' 
                      ? 'bg-[#2D2D2D]' 
                      : 'bg-[#161616]'
                  }`}
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(18px, 1.88vw, 36px)',
                    cursor: 'pointer'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8,
                      pointerEvents: 'none'
                    }}
                  >
                    Following
                  </span>
                </button>

                {/* Favorites Button */}
                <button 
                  onClick={() => setActiveTab('favorites')}
                  className={`relative border-r-4 border-[#AB0000] hover:opacity-90 transition-opacity flex items-center justify-center ${
                    activeTab === 'favorites' 
                      ? 'bg-[#2D2D2D]' 
                      : 'bg-[#161616]'
                  }`}
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(18px, 1.88vw, 36px)',
                    cursor: 'pointer'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8,
                      pointerEvents: 'none'
                    }}
                  >
                    Favorites
                  </span>
                </button>

                {/* Gallery Button */}
                <button 
                  onClick={() => setActiveTab('waitingList')}
                  className={`relative border-r-4 border-[#AB0000] hover:opacity-90 transition-opacity flex items-center justify-center ${
                    activeTab === 'waitingList' 
                      ? 'bg-[#2D2D2D]' 
                      : 'bg-[#161616]'
                  }`}
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(18px, 1.88vw, 36px)',
                    cursor: 'pointer'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(12px, 0.83vw, 16px)',
                      color: '#FFFFFF',
                      opacity: 0.8,
                      pointerEvents: 'none'
                    }}
                  >
                    Waiting List
                  </span>
                </button>
              </div>

              {activeTab === 'waitingList' && (
                <>
                  {!waitingListLoading && waitingListError && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(10px, 1.04vw, 20px)',
                        top: 'clamp(330px, 34.38vw, 660px)',
                        fontFamily: 'Keania One',
                        fontSize: 'clamp(10px, 0.94vw, 18px)',
                        color: '#FF8A8A'
                      }}
                    >
                      {waitingListError}
                    </div>
                  )}

                  {!waitingListLoading && !waitingListError && waitingListData.length > 0 && (
                    <div
                      className="absolute"
                      style={{
                        left: '0',
                        top: 'clamp(330px, 34.38vw, 660px)',
                        paddingBottom: 'clamp(80px, 8.33vw, 160px)'
                      }}
                    >
                      <div
                        className="relative"
                        style={{
                          width: 'clamp(830px, 86.46vw, 1660px)',
                          minHeight: 'clamp(500px, 52vw, 1000px)'
                        }}
                      >
                        {waitingListData.slice(0, waitingListCardPositions.length).map((collection, index) => {
                          const position = waitingListCardPositions[index];
                          if (!position) {
                            return null;
                          }

                          const slug = collection.slug || collection.id || `collection-${index}`;
                          const imagePool = Array.isArray(collection.images) && collection.images.length
                            ? collection.images
                            : Array.isArray(collection.nfts)
                              ? collection.nfts.map((nft) => nft?.imagelink).filter(Boolean)
                              : [];
                          const previewImage = (imagePool[0] || collection.previewImage || '').toString();
                          const nftCount = collection.nftCount ?? (Array.isArray(collection.nfts) ? collection.nfts.length : null);

                          const bestOffer = '11 sol';
                          const followers = '0';
                          const creator = 'Bojar';

                          return (
                            <div
                              key={slug}
                              className="absolute"
                              style={{
                                left: position.left,
                                top: position.top
                              }}
                            >
                              <div
                                onClick={() => navigate(`/collection/${slug}`)}
                                className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                                style={{
                                  width: 'clamp(190px, 19.79vw, 380px)',
                                  height: 'clamp(105px, 10.94vw, 210px)'
                                }}
                              >
                                <div
                                  className="absolute z-20 flex items-center justify-center"
                                  style={{
                                    left: '0',
                                    top: '0',
                                    width: 'clamp(32px, 3.33vw, 64px)',
                                    height: 'clamp(21px, 2.19vw, 42px)',
                                    backgroundColor: 'rgba(20, 20, 20, 0.6)'
                                  }}
                                >
                                  <img
                                    src={unLikeIconImage}
                                    alt="Waiting list indicator"
                                    style={{
                                      width: 'clamp(17px, 1.77vw, 34px)',
                                      height: 'clamp(17px, 1.77vw, 34px)'
                                    }}
                                  />
                                </div>
                                <div
                                  className="bg-black overflow-hidden"
                                  style={{
                                    width: 'clamp(120px, 12.5vw, 240px)',
                                    height: 'clamp(105px, 10.94vw, 210px)'
                                  }}
                                >
                                  {previewImage ? (
                                    <img
                                      src={previewImage}
                                      alt={collection.title || slug}
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#000000'
                                      }}
                                    />
                                  )}
                                </div>
                                <div
                                  className="flex flex-col text-center relative"
                                  style={{
                                    width: 'clamp(70px, 7.29vw, 140px)',
                                    height: 'clamp(105px, 10.94vw, 210px)',
                                    backgroundColor: 'rgba(18, 20, 38, 1)',
                                    borderTop: '2px solid #9F191A',
                                    borderRight: '2px solid #9F191A',
                                    borderBottom: '2px solid #9F191A',
                                    borderLeft: 'none'
                                  }}
                                >
                                  <div
                                    className="text-white font-normal absolute flex items-center justify-center"
                                    style={{
                                      backgroundColor: '#9F191A',
                                      top: 'clamp(10px, 1.04vw, 20px)',
                                      left: '0',
                                      width: 'clamp(70px, 7.29vw, 140px)',
                                      height: 'clamp(13px, 1.35vw, 26px)',
                                      fontSize: 'clamp(6px, 0.63vw, 12px)',
                                      lineHeight: '1',
                                      opacity: 0.8
                                    }}
                                  >
                                    {collection.title || slug}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(28px, 2.92vw, 56px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Collection Amount
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(35.5px, 3.7vw, 71px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {nftCount ?? '—'}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(45px, 4.9vw, 92px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Best Offer
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(52.5px, 5.68vw, 107px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {bestOffer}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(64.5px, 6.93vw, 131px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Followers
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(72px, 7.71vw, 146px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {followers}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(84px, 8.96vw, 170px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Created By
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(91.5px, 9.74vw, 185px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {creator}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </>
              )}

              {activeTab === 'favorites' && (
                <>
                  {!favoritesLoading && favoritesError && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(10px, 1.04vw, 20px)',
                        top: 'clamp(340px, 35.42vw, 680px)',
                        fontFamily: 'Keania One',
                        fontSize: 'clamp(10px, 0.94vw, 18px)',
                        color: '#FF8A8A'
                      }}
                    >
                      {favoritesError}
                    </div>
                  )}

                  {!favoritesLoading && !favoritesError && favoritesData.length > 0 && (
                    <div
                      className="absolute"
                      style={{
                        left: 'clamp(12px, 1.25vw, 24px)',
                        top: 'clamp(340px, 35.42vw, 680px)',
                        width: 'calc(100% - clamp(24px, 2.5vw, 48px))',
                        paddingBottom: 'clamp(80px, 8.33vw, 160px)',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 'clamp(11px, 1.15vw, 22px)'
                      }}
                    >
                      {favoritesData.map((fav, index) => {
                        const key = `${fav.slug || 'fav'}_${fav.nftIndex ?? index}`;
                        
                        return (
                          <div 
                            key={key} 
                            className="relative"
                            onMouseEnter={() => setHoveredFavoriteIndex(index)}
                            onMouseLeave={() => setHoveredFavoriteIndex(null)}
                            style={{
                              width: 'clamp(120px, 12.5vw, 240px)',
                              flexShrink: 0,
                              cursor: 'pointer'
                            }}
                          >
                            {/* Like Button - Left Top Corner */}
                            <div
                              onClick={(e) => handleRemoveFromFavorites(e, fav, index)}
                              className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                              style={{
                                left: '0',
                                top: '0',
                                width: 'clamp(27.5px, 2.86vw, 55px)',
                                height: 'clamp(20px, 2.08vw, 40px)',
                                backgroundColor: 'rgba(20, 20, 20, 0.6)',
                                borderTopLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                                borderTopRightRadius: 'clamp(2px, 0.21vw, 4px)',
                                borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)'
                              }}
                            >
                              <img
                                src={likeIcon}
                                alt="Remove from favorites"
                                style={{
                                  width: 'clamp(15px, 1.56vw, 30px)',
                                  height: 'clamp(15px, 1.56vw, 30px)',
                                  transform: animatingFavoriteIndex === index ? 'scale(0.7)' : 'scale(1)',
                                  transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                                }}
                              />
                            </div>
                            
                            {/* NFT Image */}
                            <div 
                              style={{
                                width: 'clamp(120px, 12.5vw, 240px)',
                                height: 'clamp(120px, 12.5vw, 240px)',
                                borderTopLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                                borderTopRightRadius: 'clamp(2px, 0.21vw, 4px)',
                                overflow: 'hidden',
                                backgroundColor: '#000000'
                              }}
                            >
                              {fav.nft?.imagelink ? (
                                <img 
                                  src={fav.nft.imagelink}
                                  alt={fav.nft?.name || 'Favorite NFT'}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: '#000000'
                                  }}
                                />
                              )}
                            </div>
                            {/* NFT Info Footer */}
                            <div 
                              style={{
                                width: 'clamp(120px, 12.5vw, 240px)',
                                height: 'clamp(25px, 2.6vw, 50px)',
                                backgroundColor: '#000000',
                                borderBottomLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                                borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '0 clamp(6px, 0.68vw, 13px)'
                              }}
                            >
                              <div 
                                style={{
                                  fontFamily: 'Keania One',
                                  fontWeight: 400,
                                  fontSize: 'clamp(7px, 0.73vw, 14px)',
                                  color: 'rgba(255, 255, 255, 0.8)',
                                  flex: 1,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {fav.nft?.name || `NFT ${index + 1}`}
                              </div>
                              {hoveredFavoriteIndex === index ? (
                                <div 
                                  style={{
                                    fontFamily: 'Keania One',
                                    fontWeight: 400,
                                    fontSize: 'clamp(6px, 0.63vw, 12px)',
                                    color: 'rgba(255, 255, 255, 0.8)'
                                  }}
                                >
                                  Buy
                                </div>
                              ) : (
                                <div 
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 'clamp(2px, 0.21vw, 4px)',
                                    backgroundColor: 'rgba(84, 146, 232, 0.18)',
                                    border: 'clamp(0.5px, 0.05vw, 1px) solid #5492e8',
                                    height: 'clamp(10px, 1.04vw, 20px)',
                                    padding: '0 clamp(3px, 0.31vw, 6px)',
                                    borderRadius: 'clamp(0.5px, 0.05vw, 1px)',
                                    flexShrink: 0
                                  }}
                                >
                                  <img 
                                    src={coins_1}
                                    alt="Coin"
                                    style={{
                                      width: 'clamp(6px, 0.63vw, 12px)',
                                      height: 'clamp(6px, 0.63vw, 12px)',
                                      opacity: 0.8
                                    }}
                                  />
                                  <div 
                                    style={{
                                      fontFamily: 'Keania One',
                                      fontWeight: 400,
                                      fontSize: 'clamp(6px, 0.63vw, 12px)',
                                      color: 'rgba(255, 255, 255, 0.8)'
                                    }}
                                  >
                                    0.84
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Buy Button - appears over footer on hover */}
                            {hoveredFavoriteIndex === index && (
                              <div 
                                className="absolute"
                                onClick={() => {
                                  if (fav.slug) {
                                    const indexParam =
                                      typeof fav.nftIndex === 'number' ? fav.nftIndex : 0;
                                    navigate(`/collection/${fav.slug}/purchase?nft=${indexParam}`);
                                  }
                                }}
                                style={{
                                  left: '0px',
                                  top: 'clamp(120px, 12.5vw, 240px)',
                                  width: 'clamp(120px, 12.5vw, 240px)',
                                  height: 'clamp(25px, 2.6vw, 50px)',
                                  backgroundColor: '#5492e8',
                                  borderBottomLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                                  borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                  transition: 'opacity 0.2s',
                                  zIndex: 10
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                              >
                                <div 
                                  style={{
                                    fontFamily: 'Keania One',
                                    fontWeight: 400,
                                    fontSize: 'clamp(9px, 0.94vw, 18px)',
                                    color: '#FFFFFF'
                                  }}
                                >
                                  Buy
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}

              {activeTab === 'collection' && (
                <>
                  {!collectionsLoading && collectionsError && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 'clamp(10px, 1.04vw, 20px)',
                        top: 'clamp(330px, 34.38vw, 660px)',
                        fontFamily: 'Keania One',
                        fontSize: 'clamp(10px, 0.94vw, 18px)',
                        color: '#FF8A8A'
                      }}
                    >
                      {collectionsError}
                    </div>
                  )}

                  {!collectionsLoading && !collectionsError && collectionsData.length > 0 && (
                    <div
                      className="absolute"
                      style={{
                        left: '0',
                        top: 'clamp(330px, 34.38vw, 660px)',
                        paddingBottom: 'clamp(80px, 8.33vw, 160px)'
                      }}
                    >
                      <div
                        className="relative"
                        style={{
                          width: 'clamp(830px, 86.46vw, 1660px)',
                          minHeight: 'clamp(500px, 52vw, 1000px)'
                        }}
                      >
                        {collectionsData.slice(0, waitingListCardPositions.length).map((collection, index) => {
                          const position = waitingListCardPositions[index];
                          if (!position) {
                            return null;
                          }

                          const slug = collection.slug || `collection-${index}`;
                          const previewImage = collection.previewImage || (collection.images?.[0]) || '';
                          const nftCount = collection.nftCount ?? 0;

                          const bestOffer = '11 sol';
                          const followers = '0';
                          const creator = 'Bojar';

                          return (
                            <div
                              key={slug}
                              className="absolute"
                              style={{
                                left: position.left,
                                top: position.top
                              }}
                            >
                              <div
                                onClick={() => navigate(`/collection/${slug}`)}
                                className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                                style={{
                                  width: 'clamp(190px, 19.79vw, 380px)',
                                  height: 'clamp(105px, 10.94vw, 210px)'
                                }}
                              >
                                <div
                                  onClick={(e) => handleRemoveFromCollections(e, collection, index)}
                                  className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                                  style={{
                                    left: '0',
                                    top: '0',
                                    width: 'clamp(32px, 3.33vw, 64px)',
                                    height: 'clamp(21px, 2.19vw, 42px)',
                                    backgroundColor: 'rgba(20, 20, 20, 0.6)'
                                  }}
                                >
                                  <img
                                    src={likeIcon}
                                    alt="Remove from favorites"
                                    style={{
                                      width: 'clamp(17px, 1.77vw, 34px)',
                                      height: 'clamp(17px, 1.77vw, 34px)',
                                      transform: animatingCollectionIndex === index ? 'scale(0.7)' : 'scale(1)',
                                      transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                                    }}
                                  />
                                </div>
                                <div
                                  className="bg-black overflow-hidden"
                                  style={{
                                    width: 'clamp(120px, 12.5vw, 240px)',
                                    height: 'clamp(105px, 10.94vw, 210px)'
                                  }}
                                >
                                  {previewImage ? (
                                    <img
                                      src={previewImage}
                                      alt={collection.title || slug}
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#000000'
                                      }}
                                    />
                                  )}
                                </div>
                                <div
                                  className="flex flex-col text-center relative"
                                  style={{
                                    width: 'clamp(70px, 7.29vw, 140px)',
                                    height: 'clamp(105px, 10.94vw, 210px)',
                                    backgroundColor: 'rgba(18, 20, 38, 1)',
                                    borderTop: '2px solid #9F191A',
                                    borderRight: '2px solid #9F191A',
                                    borderBottom: '2px solid #9F191A',
                                    borderLeft: 'none'
                                  }}
                                >
                                  <div
                                    className="text-white font-normal absolute flex items-center justify-center"
                                    style={{
                                      backgroundColor: '#9F191A',
                                      top: 'clamp(10px, 1.04vw, 20px)',
                                      left: '0',
                                      width: 'clamp(70px, 7.29vw, 140px)',
                                      height: 'clamp(13px, 1.35vw, 26px)',
                                      fontSize: 'clamp(6px, 0.63vw, 12px)',
                                      lineHeight: '1',
                                      opacity: 0.8
                                    }}
                                  >
                                    {collection.title || slug}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(28px, 2.92vw, 56px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Collection Amount
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(35.5px, 3.7vw, 71px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {nftCount ?? '—'}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(45px, 4.9vw, 92px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Best Offer
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(52.5px, 5.68vw, 107px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {bestOffer}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(64.5px, 6.93vw, 131px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Followers
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(72px, 7.71vw, 146px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {followers}
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(84px, 8.96vw, 170px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    Created By
                                  </div>
                                  <div
                                    className="absolute"
                                    style={{
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'clamp(91.5px, 9.74vw, 185px)',
                                      fontSize: 'clamp(5px, 0.52vw, 10px)',
                                      color: 'rgba(255, 255, 255, 0.8)',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {creator}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Empty State Message for Collection, NFTs, Following, Favorites */}
              {((activeTab === 'collection' && collectionsData.length === 0 && !collectionsLoading && !collectionsError) || activeTab === 'nfts' || activeTab === 'following' || (activeTab === 'favorites' && favoritesData.length === 0 && !favoritesLoading && !favoritesError)) && (
                <div 
                  className="absolute flex items-center justify-center"
                      style={{
                        left: '0',
                    top: 'clamp(300px, 30.38vw, 600px)',
                    width: 'clamp(830px, 86.46vw, 1660px)',
                    height: 'clamp(200px, 21.25vw, 400px)'
                  }}
                >
                  <span 
                        style={{
                      fontFamily: 'Inder, sans-serif',
                      fontWeight: 400,
                      fontSize: '18px',
                      color: 'rgba(255, 255, 255, 0.6)'
                    }}
                  >
                    {activeTab === 'collection' && "You don't have any collection's yet"}
                    {activeTab === 'nfts' && "You don't have any NFT's yet"}
                    {activeTab === 'following' && "You don't follow anyone yet"}
                    {activeTab === 'favorites' && "You don't have favorite NFT's yet"}
                  </span>
                    </div>
              )}
            </div>
          </div>
          <Footer />
          {/* Auth Modal */}
          <AuthModal 
            isOpen={isAuthModalOpen} 
            onClose={() => setIsAuthModalOpen(false)} 
          />
        </main>
      </div>
    </div>
  );
}